import React from "react";
import {Box, Card, CardContent, Typography} from "@mui/material";
import {CheckFilled, Except} from "~/ui/icons";
import makeStyles from "@mui/styles/makeStyles";
import {PortTheme} from "~/ui/theme";
import {AdmissionTypeEnum} from "~/queries";
import {GraphQLError} from "graphql";

type CreateAdmissionResultCardProps = {
    type: AdmissionTypeEnum;
    error?: GraphQLError
}

const useStyles = makeStyles<PortTheme>(theme => ({
    passCard: {
        marginBottom: 8,
    },
    passCardContent: {
        paddingTop: "10px !important",
        paddingBottom: "17px !important",
        paddingLeft: "10px !important",
        paddingRight: "10px !important",
    },
    icon: {
        width: '16px !important',
        height: '16px !important',
        marginRight: 8,
    },
}));


export const CreateAdmissionResultCard = (props: CreateAdmissionResultCardProps): JSX.Element => {
    const { type, error } = props;
    const classes = useStyles();

    return (
        <Card className={classes.passCard}>
            <CardContent className={classes.passCardContent}>
                <Typography variant="screenTitle" color="#081F32">
                    {type === AdmissionTypeEnum.Car ? 'Автомобильный пропуск' : 'Пешеходный пропуск'}
                </Typography>
                <Box display="flex" alignItems="center" marginTop={1}>
                    {
                        error ?
                            <>
                                <Except className={classes.icon}  viewBox="0 0 16 16" />
                                <Typography variant="cardText" color="secondary">
                                    Ошибка
                                </Typography>
                            </>
                            : <>
                                <CheckFilled color="additionalPrimary" className={classes.icon} />
                                <Typography variant="cardText" color="secondary">
                                    Заявка успешно создана
                                </Typography>
                            </>
                    }

                </Box>
            </CardContent>
        </Card>
    );
};
